import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  open(
    arg0: string,
    arg1: string,
    arg2: {
      panelClass: any;
      horizontalPosition: string;
      verticalPosition: string;
    }
  ) {
    throw new Error('Method not implemented.');
  }
  constructor(private _snackbar: MatSnackBar) {}

  public snackbar(message: string, action: string, type: string) {
    this._snackbar.open(message, action, {
      panelClass: type,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 2000,
    });
  }
}
